import { OPEN_STATES, isClosedState } from "../../../services/managerApi";

/**
 * Filtre et trie la liste des commandes — puis, et seulement ensuite, on
 * pagine.
 *
 * L'ordre compte. L'écran paginait d'abord côté serveur, 25 par page, puis
 * filtrait par onglet côté client. Sur les 47 476 commandes de production,
 * `delivery` en couvre 45 594 : une page de 25 ne contenait donc qu'une ou deux
 * commandes ouvertes. L'onglet « Lopend » affichait deux lignes en annonçant
 * « 1 / 12 », et les pages suivantes semblaient vides — avec un message
 * invitant à ajuster des filtres que le manager n'avait pas posés.
 *
 * Filtrer avant de découper rend le compteur de pages honnête : il décrit la
 * sélection qu'on regarde.
 */

const matchesSearch = (order, term) =>
  [order.reference, order.residentName, order.woshUserId]
    .filter(Boolean)
    .some((field) => String(field).toLowerCase().includes(term));

/** Comparateur tolérant : dates, nombres, chaînes, et valeurs absentes en fin. */
export const compareBy = (key, direction) => {
  const factor = direction === "asc" ? 1 : -1;

  return (a, b) => {
    const left = a[key];
    const right = b[key];

    if (left == null && right == null) return 0;
    // Les valeurs absentes finissent toujours en bas, quel que soit le sens :
    // une colonne vide n'est pas « la plus petite », elle est inconnue.
    if (left == null) return 1;
    if (right == null) return -1;

    if (left instanceof Date && right instanceof Date) return (left - right) * factor;
    if (typeof left === "number" && typeof right === "number") return (left - right) * factor;
    return String(left).localeCompare(String(right)) * factor;
  };
};

export const filterOrders = ({ orders = [], search = "", tab = "all", state = "", sort }) => {
  let list = orders;

  const term = search.trim().toLowerCase();
  if (term) list = list.filter((order) => matchesSearch(order, term));

  if (tab === "open") list = list.filter((order) => OPEN_STATES.includes(order.state));
  if (tab === "done") list = list.filter((order) => isClosedState(order.state));
  if (state) list = list.filter((order) => order.state === state);

  return sort ? [...list].sort(compareBy(sort.key, sort.direction)) : list;
};

export const PER_PAGE = 25;

export const pageCount = (total) => Math.max(1, Math.ceil(total / PER_PAGE));

export const pageSlice = (list, page) => list.slice((page - 1) * PER_PAGE, page * PER_PAGE);
